const canonicalMap = new Map([
  // example canonical mappings; extend as needed
  ['max', 'Max'],
  ['max w', 'Max'],
  ['max.wolters@krinkels.nl', 'Max'],
  ['maxor559955@gmail.com', 'Max'],
  ['andre', 'Andre'],
  ['andre.petit@krinkels.nl', 'Andre'],
]);

function clean(value){
  if (!value && value !== 0) return '';
  return String(value).trim().toLowerCase();
}

export function normalizeTechnician(raw = {}){
  // raw may be { uid, profileId, email, displayName }
  const uid = raw.uid || '';
  const profileId = raw.profileId || '';
  const email = raw.email || raw.eMail || '';
  const displayName = raw.displayName || raw.name || '';

  if (uid) return { canonical: uid, reason: 'uid' };
  if (profileId) return { canonical: profileId, reason: 'profileId' };

  const cleanedEmail = clean(email);
  if (cleanedEmail) {
    // Email has higher priority and should be returned as canonical (do not map to display name)
    return { canonical: cleanedEmail, reason: 'email' };
  }

  const cleanedName = clean(displayName);
  if (!cleanedName || ['-', 'null', 'undefined', 'niet geregistreerd'].includes(cleanedName)) {
    return { canonical: 'Niet geregistreerd', reason: 'empty' };
  }
  const mapped = canonicalMap.get(cleanedName);
  if (mapped) return { canonical: mapped, reason: 'alias-mapping' };
  return { canonical: cleanedName.replace(/\b(\w)/g, c => c.toUpperCase()), reason: 'displayName' };
}

export function registerAlias(key, canonical){
  if (!key || !canonical) return;
  canonicalMap.set(clean(key), canonical);
}

export default { normalizeTechnician, registerAlias };
